import { getPhoneSchema } from "Schemas/phoneSchema";
import type { TFunction } from "Translations/Resources";
import { z } from "zod";

export const getContactPersonSchema = (t: TFunction) =>
  z.object({
    publicID: z.string().nullish(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    phone: getPhoneSchema(t, { isRequired: false }),
    email: z.email().nullable(),
  });
